enum SizeSelection {
  SizingKit = 'sizing-kit',
  ChooseSize = 'choose-size',
}

export default SizeSelection;
